import { isBrowser } from '@backyard-ui/utils';

import { type HttpClient } from '@/application/interfaces/http-client';
import { APP_API_TOKEN } from '@/utils/constants/cookies';
import { AUTHORIZATION_HEADER } from '@/utils/constants/headers';
import { cookies } from '@/utils/cookies';
import {
  getIsOnMobileAppClient,
  getIsOnMobileAppServer,
} from '@/utils/get-is-on-mobile-app/get-is-on-mobile-app';

export const addAppApiToken: HttpClient.RequestInterceptor = async (
  options
) => {
  options.headers = options.headers ?? {};

  const getCookie = isBrowser ? cookies.client.get : cookies.server.get;
  const appApiToken = await getCookie(APP_API_TOKEN);

  const isOnMobileApp = isBrowser
    ? getIsOnMobileAppClient()
    : await getIsOnMobileAppServer();

  if (isOnMobileApp && appApiToken.value) {
    options.headers[AUTHORIZATION_HEADER] = `Bearer ${appApiToken.value}`;
  }

  return options;
};
